function main() {
  if (document.querySelector('.page[project="uk-projects"]')) {
    document.querySelector('.uk-btn').classList.add('active-filter');
  }

  if (document.querySelector('.page[project="aus-projects"]')) {
    document.querySelector('.aus-btn').classList.add('active-filter');
  }

  if (document.querySelector('.page[project="my-projects"]')) {
    document.querySelector('.my-btn').classList.add('active-filter');
  }
}

export default main;
